export const formatFileAnswer = (answer) => {
  if (!answer) return '';

  if (Array.isArray(answer)) {
    return answer
      .map(file => formatSingleFile(file))
      .filter(Boolean)
      .join('; ');
  }

  if (typeof answer === 'object') {
    return formatSingleFile(answer);
  }

  return answer.toString();
};

const formatSingleFile = (file) => {
  if (!file || !file.name) return '';

  const type = file.type || '';

  if (type.startsWith('image/')) return `[Image] ${file.name}`;
  if (type.startsWith('audio/')) return `[Audio] ${file.name}`;
  if (type.startsWith('video/')) return `[Video] ${file.name}`;

  return `[File] ${file.name}`;
};
